import RegisterDeliveryLogic from "../Application/RegisterDelivery.logic";
import { GetDeliveryInfoLogic, GetCollectsLogic } from "../Application/GetDeliveryInfo.logic";
import {GetDeliveryListLogic, GetDeliveryListBySearchBarLogic} from "../Application/GetDeliveryList.logic";

export async function GetDeliveryInfo() {
  const { valid, info } = await GetDeliveryInfoLogic(localStorage.getItem("id"));
  localStorage.setItem("email", info.email);
  return { valid, info };
}

export async function GetDeliveryList(zone) {
  return await GetDeliveryListLogic(zone);
}

export async function GetDeliveryListBySearchBar(zone, name){
  return await GetDeliveryListBySearchBarLogic(zone, name);
}

export async function RegisterDelivery(
  email,
  password,
  passwordRepeat,
  name,
  lastName,
  sex,
  address,
  age,
  phone
) {
  return RegisterDeliveryLogic(
    email,
    password,
    passwordRepeat,
    name,
    lastName,
    sex,
    address,
    age,
    phone
  );
}

export async function GetCollects(data){
  return GetCollectsLogic(data);
}